import { J as JS_PREFIX } from './built-constants-439d5572.js';
import './built-ajax-api-4ab76389.js';
import './built-cart-event-emitter-def8079a.js';
import './built-env-utils-ed419642.js';
import './built-config-a65ae98c.js';
import './built-loglevel-42c63e3e.js';
import './built-price-format-dc3d77ee.js';
import './built-error-message-utilities-4ca13134.js';
import './built-on-add-to-cart-59888dcc.js';
import './built-element-utils-09877efc.js';
import { i as initProductTiles } from './built-init-d0dde4b2.js';
import './built-create-state-8c555f12.js';

/**
 * Product Tiles Observer
 *
 * This module watches the DOM for changes to product tile container and
 * re-initializes the product tile hover JS when new product tiles
 * are appended to the DOM (due to AdeptMind filtering)
 *
 * This will only occur in the case that it is a product collection
 * that has filters able to be applied to it. If the page does not have filters
 * available on it, it will simply initialize the product tiles.
 *
 */
/**
 * Class applied to parent of product tile container, to watch
 * for subtree changes
 */

const PRODUCT_AREA_CLASS = JS_PREFIX + "ProductTilesObserver";
/**
 * Holds the initiated product tile observer
 */

let productTileObserver = null;
/**
 * Creates an instance of MutationObserver that will execute callback
 * when element changes. Changes to listen for are defined in a
 * MutationObserverInit object.
 *
 * @param {Node} element
 * @param {Function} callback
 * @param {MutationObserverInit} params
 *
 * @returns {MutationObserver} observer
 */

const initObserver = (element, callback, params) => {
  const observer = new MutationObserver(callback);
  observer.observe(element, params);
  return observer;
};
/**
 * Returns the parent element that we wish to observe for changes
 *
 * @returns {Node} DOM node.
 */


const getProductTileContainerParentEl = () => document.querySelector("." + PRODUCT_AREA_CLASS);
/**
 * Initializes product tiles on page load and then
 * applies a MutationObserver to the parent element of the
 * tiles container to listen for subtree changes.
 *
 * If no applicable element is found (such as product page without
 * filters), no mutation observer is initiated.
 *
 * If the mutation observer is initiated, then
 * when a child DIV of the observed element is appended, this
 * is because the original tiles have returned (all filters removed)
 * and the product tile hover JS must be re-applied.
 */


const startProductTileObserver = () => {
  initProductTiles();
  const tileContainerEl = getProductTileContainerParentEl();

  if (tileContainerEl && !productTileObserver) {
    productTileObserver = initObserver(tileContainerEl, onProductTileChange, {
      childList: true
    });
  }
};
/**
 * Action performed on change to DOM (Re-initialize product tiles)
 */


const onProductTileChange = () => {
  initProductTiles();
};
/**
 * Apply an event listener for DOMContentLoaded so that we apply the
 * product tile JS once the elements are present.
 */


const initProductTileObserver = () => {
  document.addEventListener('DOMContentLoaded', startProductTileObserver);
};

// @ts-check
initProductTileObserver();
